
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // First try to get the hash parameters
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get("access_token");
        const refreshToken = hashParams.get("refresh_token");

        // If we have hash parameters, set the session directly
        if (accessToken && refreshToken) {
          console.log("Processing magic link callback with tokens");
          const { data: { session }, error: sessionError } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (sessionError) {
            console.error("Error setting session:", sessionError);
            throw sessionError;
          }

          if (!session) {
            console.error("No session established after setting tokens");
            throw new Error("Failed to establish session");
          }

          console.log("Magic link auth successful, session established");
        } else {
          // If no hash parameters, try to get the current session
          console.log("No tokens in URL, checking for existing session");
          const { data: { session }, error: sessionError } = await supabase.auth.getSession();
          
          if (sessionError) {
            console.error("Error getting session:", sessionError);
            throw sessionError;
          }

          if (!session) {
            console.error("No session found");
            throw new Error("No authentication session found");
          }
        }

        // If we get here, we have a valid session
        toast({
          title: "Welcome!",
          description: "You have been successfully signed in.",
        });
        
        // Redirect to home page
        navigate("/", { replace: true });
      } catch (error) {
        console.error("Auth callback error:", error);
        toast({
          variant: "destructive",
          title: "Authentication failed",
          description: error instanceof Error ? error.message : "There was a problem signing you in.",
        });
        navigate("/", { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
    </div>
  );
}
